// Macro #33 acceptance fix — localized legal content model.
// Legal DRAFTS live here (one bundle per supported locale) so every Legal
// surface respects the selected language. English remains the canonical source
// text for the legal substance until professional legal review (incl. MiCA).
// `id`/`index` are technical (not translated); everything else is user-facing.

export type LegalDocId =
  | "terms"
  | "privacy"
  | "cookies"
  | "marketplace"
  | "guidelines"
  | "content-ip"
  | "risk"
  | "support"
  | "moderation";

export const LEGAL_DOC_ORDER: LegalDocId[] = [
  "terms",
  "privacy",
  "cookies",
  "marketplace",
  "guidelines",
  "content-ip",
  "risk",
  "support",
  "moderation",
];

// Technical, non-translated index badge per doc (display order).
export const LEGAL_DOC_INDEX: Record<LegalDocId, string> = {
  terms: "L · 01",
  privacy: "L · 02",
  cookies: "L · 03",
  marketplace: "L · 04",
  guidelines: "L · 05",
  "content-ip": "L · 06",
  risk: "L · 07",
  support: "L · 08",
  moderation: "L · 09",
};

export interface LegalSection {
  heading: string;
  body: string[];
}

export interface LegalDoc {
  eyebrow: string;
  title: string;
  intro: string;
  sections: LegalSection[];
}

export interface LegalBundle {
  draftNote: string;
  nav: Record<LegalDocId, string>;
  docs: Record<LegalDocId, LegalDoc>;
}
